/**
 * The chain token — the first word of a normalised supplier name — used to
 * offer a chain-wide allocation rule ("SPAR TYGERVALLEY" -> "SPAR") and to
 * find which rule or history a slip's supplier matches on the review screen.
 *
 * This is the one-line half of api/src/lib/supplierName.js. The other half,
 * normaliseSupplier(), does real cleanup (case, punctuation, company-form
 * suffixes, trailing store numbers) and stays server-side — the server
 * already returns the normalised name as `supplierNameNorm`, so the web
 * bundle only ever needs to take its first word, never to re-derive it.
 */
export const chainToken = (norm) => (norm ?? '').split(' ')[0] ?? '';
